package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{EditableWordState, EditableWordStateGenerator, RecordingTranscriptReviewStateGenerator, TestTranscriptReviewStateGenerator, VisibilityStateGenerator}
import com.neurobs.util.Interval
import com.neurobs.util.TimeSeconds
import slinky.core.{FunctionalComponent, SyntheticEvent, TagElement}
import slinky.core.annotations.react
import slinky.web.html._
import slinky.core.facade.Hooks._
import slinky.core.facade.React.createRef
import org.scalajs.dom
import org.scalajs.dom.console
import org.scalajs.dom.raw.HTMLInputElement
import slinky.core.facade.ReactRef
import slinky.web.SyntheticMouseEvent

import scala.scalajs.js

@react
object ReviewableWord {

  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val wordReviewState = EditableWordStateGenerator.accessState

    def generateStyle = {
      val attributes = wordReviewState.styleAttributes
      StyleUtil.makeStyle(attributes:_*)
    }

    div(
      style := generateStyle,
      onMouseDown := {e => wordReviewState.handleMouseDown(e)},
      onMouseMove := {e => wordReviewState.handleMouseMove(e)},
      onMouseUp := {e => wordReviewState.handleMouseUp()},
      onMouseOut := {e => wordReviewState.handleMouseOut()},
      onMouseEnter := {e => wordReviewState.handleMouseEnter()},
      ref := wordReviewState.positionRef
    )(
      WordInput()
    )
  }

}

@react
object WordInput {
  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val editableWordState = EditableWordStateGenerator.accessState

    val inputRef = createRef[dom.html.Input]

    useEffect(() => {
      if (inputRef.current != null) {
        inputRef.current.value = editableWordState.editableWord.word
      }
    }, Vector())

    def inputDivStyle = StyleUtil.makeStyle(
      ("width", "100%"),
      ("marginLeft", "0"),
      ("zIndex", "2"),
      ("position", "relative"),
    )

    def inputStyle = StyleUtil.makeStyle(
      ("marginLeft", "auto"),
      ("marginRight", "auto"),
      ("maxWidth", "80%"),
      ("color", "white"),
      ("textAlign", "center"),
      ("zIndex", "1")
    )

    def handleBlur() = {
      if (inputRef.current != null) {
        editableWordState.editContent(inputRef.current.value)
      }

    }

    div(
      className := "ui transparent input",
      style := inputDivStyle
    )(
      input(
        `type` := "text",
        ref := inputRef,
        onBlur := {() => handleBlur()},
        style := inputStyle
      ),
      DeleteButton(),
      FlagButton(),
      PlayButton(),
		 RightEdgeDivider(),
	  LeftEdgeDivider()
    )
  }
}

@react
object ActionButton {
  case class Props(
    color: String,
    handleClick: () => Unit,
    iconClass: String,
    stackPosition: Int,
    alignment: String = "left"
                  )

  val component = FunctionalComponent[Props] { props =>

    def buttonStyle = StyleUtil.makeStyle(
      ("position", "absolute"),
      ("padding", "0px"),
      ("height", "20px"),
      ("width", "20px"),
      (props.alignment, "0px"),
      ("top", s"${-20*props.stackPosition}px")
    )

    button(
      className := s"ui inverted mini ${props.color} icon button",
      style := buttonStyle,
      onClick := {() => props.handleClick()}
    )(
      i(className := props.iconClass)
    )
  }
}

@react
object DeleteButton {
  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val editableWordState = EditableWordStateGenerator.accessState
    val recordingTranscriptReviewState = RecordingTranscriptReviewStateGenerator.accessState

    def deleteWord() = {
      editableWordState.removeWord()
      recordingTranscriptReviewState.registerChange()
    }

    ActionButton("red", deleteWord, "close icon", 1)
  }
}

@react
object FlagButton {

  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val editableWordState = EditableWordStateGenerator.accessState
    val recordingTranscriptReviewState = RecordingTranscriptReviewStateGenerator.accessState

    def flagWord() = {
      editableWordState.flag()
      recordingTranscriptReviewState.registerChange()
    }

    ActionButton("yellow", flagWord, "star icon", 2)
  }
}

@react
object PlayButton {

  case class Props()

  val component = FunctionalComponent[Props] { _ =>

    val state = EditableWordStateGenerator.accessState

    def playWord() = {
		 state.testState.play(state.recordingState.recordingIndex, Interval[TimeSeconds](state.editableWord.startTime, state.editableWord.endTime))
    }

    ActionButton("green", playWord, "volume up icon", 3)
  }
}

@react
object RightEdgeDivider {
  case class Props()

  val component = FunctionalComponent[Props] { _ =>

    val visibilityState = VisibilityStateGenerator.accessState

    def dividerStyle = StyleUtil.makeStyle(
      ("borderRight", "1px solid white"),
      ("zIndex", "10"),
      ("position", "absolute"),
      ("bottom", "0"),
      ("right", "0"),
      ("height", if (visibilityState.spectrogramIsVisible) "300px" else "150px")
    )

    div(style := dividerStyle)
  }
}

@react
object LeftEdgeDivider {
  case class Props()

  val component = FunctionalComponent[Props] { _ =>

    val visibilityState = VisibilityStateGenerator.accessState

    def dividerStyle = StyleUtil.makeStyle(
      ("borderLeft", "1px solid white"),
      ("zIndex", "10"),
      ("position", "absolute"),
      ("bottom", "0"),
      ("left", "0"),
      ("height", if (visibilityState.spectrogramIsVisible) "300px" else "150px")
    )

    div(style := dividerStyle)
  }
}